<template>
    <v-container
        v-if="site"
        class="abstract-container lm-border mt-3 pa-3 " style="border-width: 1px; width: calc(100% - -9px);"
        :style="'height:' + height + 'px'"
    >

        <div class="w-100">
            <div class="step-title w-100" style="position:relative;">
                <div class=" primary--text" style="padding-top: 3px;">
                    <span>ZÜS-Prüfung für Anlage {{site.fabricNo }}</span>
                </div>
                <div class="v-flex" style="position: absolute; right: -6px">
                    <c-toolbar-button
                        :ripple = "false"
                        v-if="incidentId"
                        icon="mdi-arrow-right-thin-circle-outline"
                        color="primary"
                        size="22"
                        tooltip="Zur ZÜS Prüfung wechseln"
                        @click="onGoto"
                    />
                    <c-toolbar-button
                        :ripple = "false"
                        icon="mdi-refresh"
                        color="primary"
                        size="22"
                        tooltip="ZÜS Prüfungsliste aktualisieren"
                        @click="onRefreshAssessments"
                    />
                </div>
            </div>

            <div class="abstract-group " >
                <v-row class="no-frame abstract-info">
                    <v-col class="no-frame col-12 pr-1">
                        <v-select
                            label="Prüfung"
                            class="mt-0"
                            :items = "selections"
                            item-value     = "id"
                            item-text      = "name"
                            :return-object = true
                            :rules = "[ requiredRule ]"
                            v-model="selection"
                            @change = "onSelected"
                        />

                    </v-col>
                </v-row>

                <v-row class="no-frame abstract-info mt-5">
                    <v-col class="no-frame col-6 pr-1">
                        <f-read-only-field filled dense label="ZÜS" :value="company" />
                    </v-col>
                    <v-col class="no-frame col-6 pl-1" >
                        <f-read-only-field filled dense label="Status" :value="status" />
                    </v-col>
                </v-row>

                <v-row class="no-frame abstract-info mt-2">
                    <v-col class="no-frame col-6 pr-1">
                        <f-read-only-field filled dense label="Prüfungsergebnis" :value="result" />
                    </v-col>
                    <v-col class="no-frame col-6 pl-1" >
                        <f-read-only-field filled dense label="Datum der Prüfung" :value="assessmentDate" />
                    </v-col>
                </v-row>

                <v-row class="no-frame abstract-info mt-3">
                    <v-col class="no-frame col-6 pr-1">
                        <f-read-only-field filled dense label="Nächste Prüfung" :value= "nextAssessment" />
                    </v-col>
                    <v-col class="no-frame col-6 pl-1" >
                        <f-read-only-field
                            label="Nachprüfung bis"
                            :value="dateRemedyOfDefects"
                            filled
                            dense
                        />
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-container>
</template>

<script>

import Core           from "@/modules/core/service/Core";
import Inc            from "@/modules/inc/service/Inc";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton.vue";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";

export default {
    name: "IncAssessmentSelection",
    components: {
        FReadOnlyField,
        CToolbarButton,
    },

    props: {
        invoice: {

        },

        height: {

        }
    },

    data: () => ({
        selections: [],
        assessments: null,
        selection: null,
        assessment: {
            type               : null,
            result             : null,
            dateAssessment     : "---",
            dateNextAssessment : "---",
            dateRemedyOfDefects: "---",
            contactName        : "---",
            contactPhone       : "---",
            contactMobile      : "...",
            contactMail        : "---"
        }
    }),

    computed: {
        site () {
            return this.$store.getters.site;
        },

        incidentId () {
            if (!this.invoice || !this.invoice.reference) {
                return null;
            }

            return this.invoice.reference.incidentId;
        },

        company () {
            return this.assessment && this.assessment.company ? this.assessment.company.name : '---';
        },

        status () {
            return this.assessment && this.assessment.status ? this.assessment.status.name : '---';
        },

        result () {
            return this.assessment && this.assessment.result ? this.assessment.result.name : '---';
        },

        assessmentDate () {
            return this.assessment ? this.dateAsString( this.assessment.dateAssessment ) : '---';
        },

        nextAssessment () {
            return this.assessment ? this.dateAsString(this.assessment.dateNextAssessment) : '---';
        },

        dateRemedyOfDefects () {
            return this.assessment ? this.dateAsString(this.assessment.dateRemedyOfDefects) : '---';
        }
    },

    mounted() {
        this.onRefreshAssessments();
    },

    watch: {
        site () {
            this.onRefreshAssessments();
        },
    },

    methods: {
        requiredRule() {
            if (!this.selection) {
                return this.$t("common.required");
            }

            return true;
        },

        onRefreshAssessments () {
            this.selections = [];

            Inc.topAssessments(this.site.id).then(data => {
                this.assessments = data;
                if (data && data.length > 0) {
                    if (!this.invoice.referenceId) {
                        this.invoice.referenceId = data[0].id;
                        this.selection = null;
                    } else {
                        this.selection = this.invoice.referenceId;
                        this.assessment = this.invoice.reference;
                    }
                }

                this.selections.push ({
                    id  : null,
                    name: "---",
                });

                data.forEach (assessment => {
                    this.selections.push ({
                        id  : assessment.id,
                        name: this.dateAsString(assessment.dateAssessment) + " - " + (assessment.type ? assessment.type.name : ""),
                    });
                })
            });
        },

        onGoto () {
            Inc.goto(this, this.incidentId, this.site.id);
        },

        onSelected () {
            if (!this.selection) {
                return;
            }

            const assessment = this.assessments.find (a => a.id === this.selection.id);
            this.invoice.referenceId = this.selection.id;
            this.assessment = assessment;
            this.$emit ("selected", this.assessment)
        },

        dateAsString(value) {
            if (!value || value === '---') {
                return "---"
            }

            return Core.format.date.display(value);
        },
    }
}
</script>

<style>

</style>